/**
 * Leviathan Web - Field-level validation message
 * Quasar Prime LLC
 *
 * The message that belongs BESIDE the input, not in a banner at the top of a
 * form thirty fields long. Renders nothing when there is no error, so it can
 * be dropped under every field unconditionally.
 */

interface FieldErrorProps {
  error?: string | undefined;
}

export function FieldError({ error }: FieldErrorProps) {
  if (!error) return null;

  return (
    <p role="alert" className="text-error-red text-xs font-mono mt-1 flex items-start gap-1">
      <span aria-hidden="true">&#9650;</span>
      <span>{error}</span>
    </p>
  );
}

/**
 * Border treatment for an input that failed validation.
 *
 * Colour alone would not be enough on its own — that is what `FieldError`
 * beneath the input is for — but an operator scanning a long form for "the red
 * one" is the fastest path to the field, and the two together cover both.
 */
export function fieldBorder(hasError: boolean | undefined): string {
  return hasError
    ? 'border-error-red focus:border-error-red focus:ring-error-red'
    : 'border-panel-border focus:border-amber focus:ring-amber';
}

export default FieldError;
